'use strict';

window.EFC = window.EFC || {};

window.EFC.Hamburger = (function($) {
  var menuButton, megaNav;
  var focusTraps = [];
  
  function init() {
    menuButton = document.getElementById('menuButton');
    megaNav = document.getElementById('megaNav');
    
    // Clicking the meganav toggles it
    menuButton.addEventListener('click', function(e) {
      e.preventDefault();

      if (meganavIsOpen()) {
        closeMegaNav();
        window.EFC.closeSearch();
      }
      else {
        openMegaNav();
      }
    });

    focusTraps = buildFocusTraps();
    
    // Clicking outside the meganav closes it.
    document.body.addEventListener('click', function(e) {
      if (!document.body.classList.contains('meganav-open')) { return; }
      
      if (!elementIsInMegaNav(e.target)) {
        closeMegaNav();
      }
    });

    document.body.addEventListener('keyup', function(e) {
      if (e.key !== "Escape") { return; }
      if (!meganavIsOpen()) { return; }
      if (!elementIsInMegaNav(e.target)) { return; }
      closeMegaNav();
    });
    
    toggleMegaNavFocusables(false);
  }

  // The HTML is a bit of a mess, so we have multiple focus traps to move focus around to match the physical layout of the buttons.
  // Changing the DOM is a better solution, but this is a decent second option.
  function buildFocusTraps() {
    var focusTraps = [];
    
    // Tab goes from last social to search
    var lastSocial = $("#megaNav .social-links a").last()[0];
    var menuButton = $('#menuButton').first()[0];
    focusTraps.push(EFC.createFocusTrapKeyDownListener(lastSocial, menuButton));
    
    return focusTraps;
  }
  
  function meganavIsOpen() {
    return document.body.classList.contains('meganav-open');
  }
  
  function elementIsInMegaNav(el) {
    return !!el.closest('#menuButton, #megaNav, #searchform');
  }

  function openMegaNav() {
    megaNav.classList.add('open');
    window.EFC.openSearch();
    primaryNav.classList.add('meganav-open');
    document.body.classList.add('meganav-open');
    toggleMegaNavFocusables(true);
    menuButton.focus();
    menuButton.setAttribute('aria-expanded', 'true');
    
    focusTraps.forEach(function(t) { document.addEventListener('keydown', t); });
  }

  function closeMegaNav() {
    megaNav.classList.remove('open');
    primaryNav.classList.remove('meganav-open');
    document.body.classList.remove('meganav-open');
    window.EFC.closeSearch();
    toggleMegaNavFocusables(false);
    menuButton.focus();
    menuButton.setAttribute('aria-expanded', 'false');

    focusTraps.forEach(function(t) { document.removeEventListener('keydown', t); });
  }
  
  /**
   * Set tabIndex to 0 (focusable) or -1 (non-focusable) appropriately for each element that may appear in the meganav
   */
  function toggleMegaNavFocusables(isMegaNavFocused) {
    get$megaNavFocusable().each(function() {
      if (!!this.closest('.category-nav')) {
        this.tabIndex = isMegaNavFocused ? 0 : -1;
      }
      else if (!!this.closest('.social-links')) {
        this.tabIndex = isMegaNavFocused ? 0 : -1;
      }
      else if (!!this.closest('#searchform')) {
        this.tabIndex = isMegaNavFocused ? 0 : 0;
      }
    });
      
    get$megaNavUnfocusable().each(function() { this.tabIndex = isMegaNavFocused ? -1 : 0; });
  }
  
  function get$megaNavFocusable() {
    return $('#menuButton, #megaNav, #searchform, #primaryNav .logo, .alternate-language')
      .find('input:not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], area[href], button, iframe, object, embed, [tabindex]:not([disabled]), [contenteditable]');
  }

  /**
   * @return jquery selector for elements that appear between focusable elements of the meganav, but are not themselves focusable
   *    when the meganav is open.
   */
  function get$megaNavUnfocusable() {
    return $('#primaryNav').find('.newsletter-link')
      .add($('#menu-category-list a'));
  }

  
  $(init);
  
  return {
    
  };
})(jQuery);